var endpointMap = {
	ar: {
		PNFRetractDisputeStrings: "translation-ar.json"
	},
	"ar-AE": {
		PNFRetractDisputeStrings: "translation-ar.json"
	},
	bn: {
		PNFRetractDisputeStrings: "translation-bn.json"
	},
	"bn-IN": {
		PNFRetractDisputeStrings: "translation-bn.json"
	},
	cs: {
		PNFRetractDisputeStrings: "translation-cs.json"
	},
	"cs-CZ": {
		PNFRetractDisputeStrings: "translation-cs.json"
	},
	da: {
		PNFRetractDisputeStrings: "translation-da.json"
	},
	"da-DK": {
		PNFRetractDisputeStrings: "translation-da.json"
	},
	de: {
		PNFRetractDisputeStrings: "translation-de.json"
	},
	"de-DE": {
		PNFRetractDisputeStrings: "translation-de.json"
	},
	en: {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-AE": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-AU": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-CA": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-GB": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-IE": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-IN": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-SG": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-US": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	"en-ZA": {
		PNFRetractDisputeStrings: "translation-en.json"
	},
	es: {
		PNFRetractDisputeStrings: "translation-es.json"
	},
	"es-ES": {
		PNFRetractDisputeStrings: "translation-es.json"
	},
	"es-MX": {
		PNFRetractDisputeStrings: "translation-es.json"
	},
	"es-US": {
		PNFRetractDisputeStrings: "translation-es.json"
	},
	fr: {
		PNFRetractDisputeStrings: "translation-fr.json"
	},
	"fr-BE": {
		PNFRetractDisputeStrings: "translation-fr.json"
	},
	"fr-CA": {
		PNFRetractDisputeStrings: "translation-fr.json"
	},
	"fr-FR": {
		PNFRetractDisputeStrings: "translation-fr.json"
	},
	he: {
		PNFRetractDisputeStrings: "translation-he.json"
	},
	"he-IL": {
		PNFRetractDisputeStrings: "translation-he.json"
	},
	hi: {
		PNFRetractDisputeStrings: "translation-hi.json"
	},
	"hi-IN": {
		PNFRetractDisputeStrings: "translation-hi.json"
	},
	id: {
		PNFRetractDisputeStrings: "translation-id.json"
	},
	"id-ID": {
		PNFRetractDisputeStrings: "translation-id.json"
	},
	it: {
		PNFRetractDisputeStrings: "translation-it.json"
	},
	"it-IT": {
		PNFRetractDisputeStrings: "translation-it.json"
	},
	ja: {
		PNFRetractDisputeStrings: "translation-ja.json"
	},
	"ja-JP": {
		PNFRetractDisputeStrings: "translation-ja.json"
	},
	kn: {
		PNFRetractDisputeStrings: "translation-kn.json"
	},
	"kn-IN": {
		PNFRetractDisputeStrings: "translation-kn.json"
	},
	ko: {
		PNFRetractDisputeStrings: "translation-ko.json"
	},
	"ko-KR": {
		PNFRetractDisputeStrings: "translation-ko.json"
	},
	ml: {
		PNFRetractDisputeStrings: "translation-ml.json"
	},
	"ml-IN": {
		PNFRetractDisputeStrings: "translation-ml.json"
	},
	mr: {
		PNFRetractDisputeStrings: "translation-mr.json"
	},
	"mr-IN": {
		PNFRetractDisputeStrings: "translation-mr.json"
	},
	nl: {
		PNFRetractDisputeStrings: "translation-nl.json"
	},
	"nl-BE": {
		PNFRetractDisputeStrings: "translation-nl.json"
	},
	"nl-NL": {
		PNFRetractDisputeStrings: "translation-nl.json"
	},
	pl: {
		PNFRetractDisputeStrings: "translation-pl.json"
	},
	"pl-PL": {
		PNFRetractDisputeStrings: "translation-pl.json"
	},
	pt: {
		PNFRetractDisputeStrings: "translation-pt.json"
	},
	"pt-BR": {
		PNFRetractDisputeStrings: "translation-pt.json"
	},
	"pt-PT": {
		PNFRetractDisputeStrings: "translation-pt.json"
	},
	sv: {
		PNFRetractDisputeStrings: "translation-sv.json"
	},
	"sv-SE": {
		PNFRetractDisputeStrings: "translation-sv.json"
	},
	ta: {
		PNFRetractDisputeStrings: "translation-ta.json"
	},
	"ta-IN": {
		PNFRetractDisputeStrings: "translation-ta.json"
	},
	te: {
		PNFRetractDisputeStrings: "translation-te.json"
	},
	"te-IN": {
		PNFRetractDisputeStrings: "translation-te.json"
	},
	th: {
		PNFRetractDisputeStrings: "translation-th.json"
	},
	"th-TH": {
		PNFRetractDisputeStrings: "translation-th.json"
	},
	tr: {
		PNFRetractDisputeStrings: "translation-tr.json"
	},
	"tr-TR": {
		PNFRetractDisputeStrings: "translation-tr.json"
	},
	und: {
		PNFRetractDisputeStrings: "translation.json"
	},
	zh: {
		PNFRetractDisputeStrings: "translation-zh.json"
	},
	"zh-CN": {
		PNFRetractDisputeStrings: "translation-zh.json"
	},
	"zh-TW": {
		PNFRetractDisputeStrings: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
